import { Box, Button, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface IBottomIconButtonProps {
    icon?: JSX.Element;
    frontIcon?: JSX.Element;
    title: string;
    onClick?: () => void;
}

export function BottomIconButton(props: IBottomIconButtonProps) {
    const { icon, frontIcon, title, onClick } = props;
    const { t } = useTranslation();
    return (
        <Box sx={{
            position: 'fixed', // Change this to 'fixed'
            bottom: 0,
            left: 0,
            right: 0,
            height: 100,
            width: '100%',
            display: 'flex',           // Add this to make it a flex container
            justifyContent: 'center',  // Center horizontally
            alignItems: 'center',
            boxShadow: '0px -4px 6px -1px rgba(0,0,0,0.2)', // Top shadow only
            backgroundColor: 'background.paper'

        }}>
            <Button
                variant="contained"
                size="small"
                sx={{
                    width: 'calc(100% - 40px)',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: 2,
                }}
                onClick={onClick}
            >
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 0.5, gap: 1 }}>
                    {frontIcon && React.cloneElement(frontIcon, { sx: { width: 40, height: 40 } })}
                    <Typography sx={{ fontSize: 22, fontWeight: 'bold', textTransform: 'initial' }}>{t(title)}</Typography>
                    {icon && React.cloneElement(icon, { sx: { width: 40, height: 40 } })}
                </Box>
            </Button>
        </Box>
    );
}
